import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';

import Login from "./components/Login";
import TeamManagementSystem from "./components/TeamManagementSystem";
import Timesheet from "./components/Timesheet";
import PreferencesPage from "./components/PreferencesPage";
import LeaveDashboard from "./components/LeaveDashboard";
import LeaveHistory from "./components/LeaveHistory";
import MyTeamLeave from "./components/MyTeamLeave";
import OrganizationLeaveHistory from "./components/OrganizationLeaveHistory";

import ReportsPage from "./components/Reports";
import MyAttendanceDashboard from "./components/MyAttendanceDashboard"; // Force rebuild
import AuthGuard from "./guards/AuthGuard";
import RoleGuard from "./guards/RoleGuard";

import AdminAttendanceReportPage from "./components/AdminAttendanceReportPage";
import AttendanceReportPage from "./components/Attendancereportpage";
import LeavePolicyPage from "./components/LeavePolicyPage";
import HolidaysPage from "./components/HolidaysPage";
import LeaveTypesPage from "./components/LeaveTypes";
import ApplyLeavePage from "./components/ApplyLeavePage";
import EmployeeRequestForm from "./components/EmployeeRequestForm";
import EmployeeMaster from "./components/Employeemaster";
import Master from "./components/Master";
import DailyAttendanceReport from "./components/DailyAttendanceReport";
import LopReport from "./components/LopReport";
import ProjectMaster from "./components/ProjectMaster";
import ReportSettings from "./components/ReportSettings";
import CheckinSettings from "./components/CheckinSettings";
import OfficeLocations from "./components/OfficeLocations";
import OutOfOfficeReport from "./components/OutOfOfficeReport";
import AllTimesheets from "./components/AllTimesheets";
import AuditTrailPage from "./components/AuditTrail";
// CSS
import "./styles/login.css";
import "./styles/forgot.css";
import "./styles/reset.css";
import "./styles/leaveDashboard.css";
import "./styles/applyleave.css";
import "./styles/applyleaveform.css";
import "./styles/TeamManagementSystem.css";
import "./styles/holidaysPage.css";
import "./styles/leavePoliciesPage.css";
import "./styles/leaveTypes.css";
import "./styles/applyLeavePage.css";
import "./styles/leaveHistory.css";
import "./styles/myTeamLeave.css";
import "./styles/organizationLeave.css";
import "./styles/employeemaster.css";
import "./styles/master.css";
import "./styles/projectmaster.css";
import "./styles/reportsettings.css";
import "./styles/audittrail.css";

export default function App() {
  return (
    <>
      <Routes>
        {/* Root should render Login (Azure redirects here) */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        {/* Protected routes */}
        <Route element={<AuthGuard />}>
          <Route path="/team" element={<TeamManagementSystem />} />


          <Route path="/timesheet" element={<Timesheet />} />

          <Route element={<RoleGuard allowedRoles={["ADMIN"]} />}>
            <Route path="/preferences" element={<PreferencesPage />} />
            <Route path="/master" element={<Master />} />
            <Route path="/holidays" element={<HolidaysPage />} />
            <Route path="/policy" element={<LeavePolicyPage />} />
            <Route path="/type" element={<LeaveTypesPage />} />
            <Route path="/all-timesheets" element={<AllTimesheets />} />
            <Route path="/audit-trail" element={<AuditTrailPage />} />
            <Route path="/checkin-settings" element={<CheckinSettings />} />
            <Route path="/office-locations" element={<OfficeLocations />} />
            <Route path="/reports/out-of-office" element={<OutOfOfficeReport />} />
          </Route>

          {/* Other Protected routes */}
          <Route path="/my-attendance" element={<MyAttendanceDashboard />} />
          <Route path="/dashboard" element={<LeaveDashboard />} />
          <Route path="/LeaveForm" element={<ApplyLeavePage />} />
          <Route path="/employee-request" element={<EmployeeRequestForm />} />
          <Route path="/Leave-History" element={<LeaveHistory />} />
          <Route path="/MyTeamLeave" element={<MyTeamLeave />} />
          <Route path="/org-leave" element={<OrganizationLeaveHistory />} />
          <Route path="/employee-master" element={<EmployeeMaster />} />
          <Route path="/project-master" element={<ProjectMaster />} />
          <Route path="/report-settings" element={<ReportSettings />} />

          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/reports/admin-attendance-report" element={<AdminAttendanceReportPage />} />
          <Route path="/reports/attendance-report" element={<AttendanceReportPage />} />
          <Route path="/reports/daily-attendance" element={<DailyAttendanceReport />} />
          <Route path="/reports/lop-report" element={<LopReport />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>





      <Toaster position="top-right" containerStyle={{ zIndex: 999999 }} />
    </>
  );
}

